/* eslint-disable max-len */
import { Input as InputPrimitive } from '@base-ui/react/input';
import * as React from 'react';

import { cn } from '@ui/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, onWheel, ...props }, ref) => {
    const scrollPageInsteadOfSteppingValue = (event: React.WheelEvent<HTMLInputElement>) => {
      if (type === 'number') {
        event.currentTarget.blur();
      }
      onWheel?.(event);
    };

    return (
      <InputPrimitive
        ref={ref}
        type={type}
        onWheel={scrollPageInsteadOfSteppingValue}
        data-slot="input"
        autoComplete="off"
        data-lpignore="true"
        data-1p-ignore="true"
        data-bwignore="true"
        data-form-type="other"
        className={cn(
          'h-12 w-full min-w-0 rounded-lg border border-input bg-background px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&::-webkit-inner-spin-button]:mr-1 [&::-webkit-inner-spin-button]:my-1',
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
